import React from 'react';
import styled from 'styled-components';

import { colors } from 'theme';

const StyledPaper = styled.div`
  padding: 1rem;

  border: solid 1px ${colors.grey_100};

  background-color: ${colors.white};

  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.5);
`;

interface PaperProps {
  children?: React.ReactNode;
}

const Paper: React.FC<PaperProps> = ({ children }) => {
  return <StyledPaper>{children}</StyledPaper>;
};

export default Paper;
